import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export type PublicCoupon = {
  code: string;
  discount_type: "percent" | "fixed";
  discount_value: number;
  label: string | null;
  active: boolean;
  starts_at: string | null;
  ends_at: string | null;
  max_uses: number | null;
  times_used: number | null;
} | null;

export const lookupCouponByCode = createServerFn({ method: "POST" })
  .inputValidator(z.object({ code: z.string().min(1).max(64) }).parse)
  .handler(async ({ data }): Promise<PublicCoupon> => {
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const { data: row, error } = await supabaseAdmin
      .from("ecom_coupons")
      .select("code,discount_type,discount_value,label,active,starts_at,ends_at,max_uses,times_used")
      .ilike("code", data.code)
      .limit(1)
      .maybeSingle();
    if (error || !row) return null;
    return {
      code: String(row.code),
      discount_type: row.discount_type === "fixed" ? "fixed" : "percent",
      discount_value: Number(row.discount_value),
      label: (row.label as string | null) ?? null,
      active: Boolean(row.active),
      starts_at: (row.starts_at as string | null) ?? null,
      ends_at: (row.ends_at as string | null) ?? null,
      max_uses: (row.max_uses as number | null) ?? null,
      times_used: (row.times_used as number | null) ?? null,
    };
  });